<template>
<v-window v-model="window" vertical touchless >
  <v-window-item >
    <v-card flat>
      <request-status :request='requests.send' ></request-status>
      <v-list three-line dark >
        <invoice-list-item :invoice='invoiceDetail' >
          <template slot='actionsAfter' >
            <v-list-tile-action >
              <strong class='subheading mt-3' >
                {{ formatCurrency(invoiceDetail.currency, invoiceDetail.amount_due) }}
              </strong>
              <v-list-tile-action-text>Due</v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-action >
              <v-progress-circular v-if='requests.get.loading' indeterminate color='amber' width='2' >
              </v-progress-circular>
              <v-btn icon target='_blank'
                v-if='invoicePreviewUrl'
                :href='invoicePreviewUrl' ><v-icon>open_in_new</v-icon></v-btn>
            </v-list-tile-action>
          </template>
        </invoice-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-text>
        <strong>Medical Aid Information as displayed on invoice:</strong>
        <pre class='text-small mad pa-2'>{{invoiceDetail.medicalaid_details}}</pre>

        <v-window v-model="step" touchless >
          <v-window-item >
            <v-subheader class='overline pl-0' >
              Choose a medical aid
            </v-subheader>
            <v-text-field readonly outline persistent-hint
              @click:append='choosemedicalaiddialog=true'
              @click='choosemedicalaiddialog=true'
              :value='medicalaid.name' class='mt-3'
              :hint='medicalAidHint'
              label='medical aid'
              append-icon='arrow_drop_down' >
            </v-text-field>
            <v-chip @click='step=1' class='v-chip--x-small' outline >
              Use a custom email
              <v-icon small right >chevron_right</v-icon>
            </v-chip>
          </v-window-item >
          <v-window-item >
            <v-subheader class='overline pl-0' >
              Custom email address
            </v-subheader>
            <v-text-field outline persistent-hint clearable
              v-model='customemail'
              type='email'
              class='mt-3'
              hint='Write the email address for the medical aid you want to send this invoice to'
              label='Enter an email address' >
            </v-text-field>
            <v-chip @click='step=0' class='v-chip--x-small' outline >
              <v-icon small left >chevron_left</v-icon>
              Search for an email
            </v-chip>
          </v-window-item >
        </v-window>

        <v-bottom-sheet v-model='choosemedicalaiddialog' scrollable :fullscreen='$vuetify.breakpoint.xsOnly' >
          <!-- <v-toolbar class='visible-xs-only' dense flat >
            <v-spacer></v-spacer>
            <v-btn @click='choosemedicalaiddialog=false' icon ><v-icon>close</v-icon></v-btn>
          </v-toolbar> -->
          <v-sheet height='600'>
            <medical-aid-picker
              v-model='medicalaid'
              @input='choosemedicalaiddialog=false' >
            </medical-aid-picker>
          </v-sheet>
        </v-bottom-sheet>
        <!-- {{customemail}}|{{medicalAidEmail}}|{{step}} -->
        <v-divider class='mt-2' />
        <v-layout v-if='medicalAidEmail' row wrap >
          <v-flex xs12 sm6 >
            <v-radio-group class='mt-0 pt-0' v-model="sendFrom">
              <v-subheader class='pa-0 overline' >Send from
                <help-popover class='ml-4' >
                  The medical aid will send status updates to this email address
                </help-popover>
              </v-subheader>
              <v-radio persistent-hint
                value='me'
                label='Send from my email address'
                hint='Replies and notifications from medical aid will come to this email address' >
              </v-radio>
              <v-radio persistent-hint
                :disabled='!clientHasEmail'
                value='client'
                label="Send from the client's email address"
              hint='Replies and notifications from medical aid will be sent to your client' >
              </v-radio>
              <!-- <small>{{clientEmail}}</small> -->
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm6 >
            <v-radio-group class='mt-0 pt-0' v-model="reimburse">
              <v-subheader class='pa-0 overline' >
                Who should be re-imbursed
                <help-popover class='ml-4' >
                  We'll add a note to the email.
                  We can't guarantee the provider will necessary get this right though
                </help-popover>
              </v-subheader>
              <v-radio persistent-hint
                value='me'
                label='Me' >
              </v-radio>
              <v-radio persistent-hint
                value='client'
                label="Client">
              </v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 >
            <v-switch v-model='ccme' label='cc me on the email' />
          </v-flex>
        </v-layout>

      </v-card-text>
      <div v-if='medicalAidEmail' class='blue lighten-4 pa-1 px-3'>
            <v-subheader class='overline pl-0'>
              <v-icon class='mr-2' small>info</v-icon>
              Invoice will be sent</v-subheader>
            <div v-if='step === 0' >
              to: <strong>{{medicalaid.name}} &laquo;{{medicalAidEmail}}&raquo;</strong>
            </div>
            <div v-if='step === 1' >
              to: <strong>&laquo;{{medicalAidEmail}}&raquo;</strong>
            </div>
            <div v-if='fromPerson && fromPerson.email' >
              from: <strong>{{fromPerson.first_name}} {{fromPerson.last_name}} &laquo;{{fromPerson.email}}&raquo;</strong>
            </div>
            <div v-if='ccme' >
              cc: <strong>{{me.first_name}} {{me.last_name}} &laquo;{{me.email}}&raquo;</strong>
            </div>
      </div>
      <v-card-actions >
        <v-btn flat text v-if='withCancel' @click='$emit("close")' >Cancel</v-btn>
        <v-spacer ></v-spacer>
        <v-btn
          :loading='requests.send.loading'
          :disabled='!medicalAidEmail'
          color='primary' @click='send' >Send
          <v-icon class='ml-2 small' >send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item >
  <v-window-item >
    <v-card flat class='text-center'>
      <center>
        <template >
          <h3 class='pt-4 headline' >Invoice submitted</h3>
          <v-icon class='pa-4' size='72' color='success' >check_circle</v-icon>
          <message-delivery-status :batch-id='batchId' >
          </message-delivery-status>
        </template>
      </center>
      <v-divider class='mt-5' ></v-divider>
      <v-card-actions >
        <v-btn @click='$emit("close");window=0' flat >Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item >
</v-window>
</template>
<script>
import MedicalAidPicker from '@/components/pickers/MedicalAidPicker'
import HelpPopover from '@/components/ui/HelpPopover'
import InvoiceListItem from '@/components/invoice/InvoiceListItem'
import MessageDeliveryStatus from '@/components/unibox/MessageDeliveryStatus'
import RequestStatus from '@/components/ui/RequestStatus'
export default {
  name: 'SendToMedicalAid',
  components: {InvoiceListItem, HelpPopover, MedicalAidPicker, MessageDeliveryStatus, RequestStatus},
  props: {
    invoice: { type: Object, required: true },
    withCancel: { type: Boolean, default: false }
  },
  data () {
    return {
      choosemedicalaiddialog: false,
      window: 0,
      step: 0,
      customemail: null,
      sendFrom: 'me',
      reimburse: 'me',
      ccme: true,
      medicalaid: {},
      invoiceDetail: {},
      requests: {
        get: {
          resource: 'invoiceguru.invoices'
        },
        send: {
          resource: 'invoiceguru.invoices'
        }
      }
    }
  },
  watch: {
    invoiceId: {
      immediate: true,
      handler () {
        if (this.invoiceId) {
          this.window = 0
          this.step = 0
          this.setInitialState()
          this.invoiceDetail = this.invoice
          this.getInvoice()
          this.batchId = Math.random().toString().replace('.', '')
        }
      }
    },
    getInvoiceStatus () {
      if (this.getInvoiceStatus === 200) {
        this.invoiceDetail = this.requests.get.result
      }
    },
    sendStatus () {
      if (this.sendStatus === 200) {
        this.window = 1
      }
    }
  },
  computed: {
    medicalAidSelected () {
      if (this.medicalaid && this.medicalaid.name) { return true }
      return false
    },
    invoiceId () {
      if (this.invoice) { return this.invoice.id }
      return null
    },
    invoicePreviewUrl () {
      let base = this.$invoiceguru.baseUrl
      if (this.invoiceDetail && this.invoiceDetail.get_download_url) {
        return `${base}${this.invoiceDetail.get_download_url}`
      }
      return false
    },
    getInvoiceStatus () {
      return this.requests.get.status
    },
    sendStatus () {
      return this.requests.send.status
    },
    me () {
      return this.invoiceDetail.practitioner_data
    },
    clientEmail () {
      if (this.clientHasEmail) {
        return this.invoiceDetail.client_data.email
      }
      return null
    },
    clientHasEmail () {
      if (this.invoiceDetail.client_data && this.invoiceDetail.client_data.email) {
        return true
      }
      return false
    },
    fromPerson () {
      if (this.sendFrom === 'me') {
        return this.invoiceDetail.practitioner_data
      }
      if (this.sendFrom === 'client') {
        return this.invoiceDetail.client_data
      }
      return null
    },
    medicalAidHint () {
      if (this.medicalaid && this.medicalaid.email) {
        return `Claims email for ${this.medicalaid.name} is ${this.medicalaid.email}`
      }
      return 'Please choose a medical aid'
    },
    medicalAidEmail () {
      if (this.step === 0) {
        return this.medicalaid.email
      }
      if (this.step === 1) {
        let isValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.customemail)
        if (isValid) { return this.customemail }
      }
      return null
    },
    payload () {
      return {
        sender: this.sendFrom,
        reimburse: this.reimburse,
        cc_me: this.ccme,
        bcc_me: this.bccme,
        medical_aid_email: this.medicalAidEmail,
        batch_id: this.batchId
      }
    }
  },
  methods: {
    getInvoice () {
      if (this.invoiceId) {
        this.requests.get.resourceId = this.invoiceId
        this.$request('get', this.requests.get)
      }
    },
    send () {
      this.requests.send.resourceId = this.invoiceId
      this.requests.send.extra = 'send_to_medical_aid'
      this.requests.send.method = 'post'
      this.requests.send.data = this.payload
      this.$request('save', this.requests.send)
    },
    setInitialState () {
      this.medicalaid = {}
      this.customemail = ''
      this.sendFrom = 'me'
      this.ccme = true
      this.reimburse = 'me'
    }
  }
}
</script>
<style scoped>
.text-small { font-size: smaller; }
.mad { border: solid 1px; }
</style>



// WEBPACK FOOTER //
// SendToMedicalAid.vue?22af1b3c